import React from 'react';

/**
 * Wrap Recharts components to  ❶ delay rendering until the mount tick
 *                              ❷ protect the UI from runtime chart errors
 */
const SafeChart = ({ chartsReady, children, fallback = null }) => {
  if (!chartsReady) {
    return (
      fallback || (
        <div className="flex items-center justify-center h-64 bg-white/[0.03] rounded-lg">
          Loading chart…
        </div>
      )
    );
  }

  try {
    return children;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Chart rendering error:', err);
    return (
      <div className="flex items-center justify-center h-64 bg-red-50 rounded-lg text-red-600">
        Chart unavailable
      </div>
    );
  }
};

export default SafeChart;
